import defaultConfig from './defaultConfig';

export default defaultConfig;
